<template>
	<div ref="editor_body">
		<h2 class="is-subtitle">Kommentare</h2>
		<div class="editor_body">
			<div style="display: flex; justify-content: end; cursor: pointer"
				@click="() => (this.referencedComment = undefined)" v-if="referencedComment" class="mr-2">
				<b-icon icon="close"></b-icon>
			</div>
			<CommentTreePrevious :comment="referencedComment" />
			<editor ref="editor" v-model="commentInput" v-on:input="$v.commentInput.$touch" />
			<b-button class="mt-3 commitComment" type="is-primary" v-on:click="saveComment" v-bind:loading="isLoading"
				v-bind:disabled="$v.commentInput.$invalid">Kommentar absenden</b-button>
		</div>
		<div class="mt-4" v-if="comments">
			<div v-for="comment in getSortedComment(comments)" :key="comment.id"
				style="position: relative; height: 100%">
				<CommentTree class="pt-2" :comment="comment" :reply="reply" :padded="false" style="height: 100%" />
				<hr class="m-1 mb-2" style="background-color: rgba(0, 0, 0, 0.3)" />

			</div>
		</div>
	</div>
</template>

<script>
/**
 * Component for the display of comments of an entry and the comment creation.
 * @displayName EntryComment
 */

import Parse from "parse/dist/parse.min.js";
import Editor from "@/components/helper/Editor";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import CommentTree from "@/components/helper/CommentTree";
import CommentTreePrevious from "@/components/helper/CommentTreePrevious";

export default {
	name: "EntryComment",
	props: ["parent"],
	data() {
		return {
			commentInput: "",
			isLoading: false,
			htmlRegex: /<\/?[^>]+(>|$)/g,
			referencedComment: undefined,
		};
	},
	computed: {
		...mapGetters({
			comments: "recordcomments/getFilteredRecordComments",
		}),
		commentKeys() {
			if (!this.comments) return []
			return Object.keys(this.comments)
		},
	},
	created() { },
	updated() { },

	validations: {
		commentInput: { required },
	},
	methods: {
		getSortedComment(commentArray) { //sorting for the first layer of the graph (esp. unconnected nodes)
			return commentArray.sort((c1, c2) => {
				if (c2.createdAt && c1.createdAt) {
					return c2.createdAt.getTime() - c1.createdAt.getTime()
				}
				if (c1.createdAt && c2[0].createdAt) { //first or second item is array caused by data structure needed from vue js
					return c2[0].createdAt.getTime() - c1.createdAt.getTime()
				}
				if (c2.createdAt && c1[0].createdAt) {
					return c2.createdAt.getTime() - c1[0].createdAt.getTime()
				}
				if (c2[0].createdAt && c1[0].createdAt) {
					return c2[0].createdAt.getTime() - c1[0].createdAt.getTime()
				}
				return 0
			})
		},
		saveComment() {
			this.isLoading = true;

			const currentUser = Parse.User.current();

			const Comment = Parse.Object.extend("RecordComment");
			const comment = new Comment();
			comment.set("author", currentUser);
			comment.set("parent", this.parent);
			comment.set("text", this.commentInput);
			comment.set("reference", this.referencedComment);
			comment
				.save()
				.then(() => {
					this.referencedComment = undefined;
					this.$buefy.toast.open({
						message: "Kommentar angelegt!",
						type: "is-success",
						position: "is-bottom",
					});
					this.isLoading = false;
					this.commentInput = "";
				})
				.catch((err) => {
					this.$buefy.toast.open({
						message: err.toString(),
						type: "is-danger",
						position: "is-bottom",
					});
					this.isLoading = false;
				});
		},
		reply(comment) {
			this.referencedComment = comment;
			
			let count =
				this.$parent.$refs.commentComponent.$el.offsetTop -
				this.$parent.$refs.commentparentComponent.scrollTop; // - xx // xx = any extra distance from top ex. 60
			this.$parent.$refs.commentparentComponent.scrollBy({
				top: count,
				left: 0,
				behavior: "smooth",
			});
			this.$refs.editor.editor.commands.focus("end");
		},
		isReferenced(comment) {
			const commentReferences = this.comments.filter(c => c.attributes.reference)
			const commentReferenceIds = commentReferences.map(ref => ref.id)
			return !commentReferenceIds.includes(comment.id)
		},
	},
	components: { CommentTreePrevious, CommentTree, Editor },
};
</script>

<style lang="scss" scoped>
/* Basic editor styles */
::v-deep .ProseMirror {
	//background-color: #f5f5f5;
	padding: 10px;

	>*+* {
		margin-top: 0.75em;
	}

	code {
		background-color: rgba(#616161, 0.1);
		color: #616161;
	}

	blockquote {
		padding-left: 1rem;
		border-left: 2px solid rgba(#0d0d0d, 0.1);
	}
}

::v-deep .content {
	padding: 1rem 0 0;

	h3 {
		margin: 1rem 0 0.5rem;
	}

	pre {
		border-radius: 5px;
		color: #333;
	}

	code {
		display: block;
		white-space: pre-wrap;
		padding: 0.75rem 1rem;
		background-color: #e9ecef;
		color: #495057;
	}
}

::v-deep .editor_body {
	border: 1px solid lightgrey;
	padding: 10px;
}

::v-deep .editor_body .buttons {
	margin-bottom: 0px;
}

::v-deep .editor_body .buttons button {
	padding: 0px 10px;
	height: auto;
}

::v-deep blockquote {
	padding-left: 1rem;
	border-left: 2px solid rgba(#0d0d0d, 0.1);
	background-color: rgba(#616161, 0.1);
	padding-bottom: 5px;
	padding-top: 5px;
}

::v-deep blockquote hr {
	margin-top: 3px;
	margin-bottom: 3px;
}

.box {
	margin: 0.5em;
}

.scrollable {
	overflow: auto;
	height: 600px;
}

.scrollable::-webkit-scrollbar {
	display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scrollable {
	-ms-overflow-style: none;
	/* IE and Edge */
	scrollbar-width: none;
	/* Firefox */
}

.articleContainer {
	display: grid;
	grid-template-columns: 1fr 9fr;
}

.authorPicture {
	height: 100%;
	width: 100%;
	object-fit: cover;
}

@media (max-width: 400px) {
	.authorPicture {
		height: 80%;
		width: 80%;
		object-fit: cover;
	}
}
</style>
